<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <!-- L'esito positivo nel linguaggio BEIZY: superficie bianca bordata nera
       2px con la spunta in petrol, come l'esito dell'import XML. Il verde
       pastello non appartiene alla palette dell'app. -->
  <div class="mt-3 izy-success-box izy-sharp-bl">
    <mat-icon class="izy-success-icon">check_circle</mat-icon>
    <p class="izy-success-message">
      {{ data.documentType }} per <strong>{{ data.companyName }}</strong>
      {{ data.text }}
    </p>
  </div>

  <p class="izy-success-hint">
    Puoi scaricare subito il PDF oppure inviarlo per email al cliente.
  </p>
</mat-dialog-content>

<mat-dialog-actions class="izy-dialog-actions">
  <!-- Le due strade che il documento puo' prendere ora, piu' l'uscita. Il
       petrol pieno sta sullo scarico, l'azione piu' diretta; l'invio e' la
       pillola bianca. -->
  <div class="izy-actions-row">
    <!-- Chiudere senza fare ne' l'uno ne' l'altro e' legittimo (il documento e'
         gia' creato), ma resta l'uscita e non una terza strada: sta sulla
         stessa riga, staccata a sinistra e come testo, non come pillola. -->
    <button
      mat-button
      type="button"
      (click)="closeDialog()"
      class="izy-close-button">
      Chiudi
    </button>

    <button
      mat-stroked-button
      type="button"
      (click)="sendEmail()"
      class="izy-button-ghost izy-button-ghost--info custom-button-border">
      <mat-icon>outgoing_mail</mat-icon>
      Invia email
    </button>

    <button
      matButton="filled"
      type="button"
      (click)="downloadPdf()"
      class="izy-button-primary custom-button-border">
      <mat-icon>download</mat-icon>
      Scarica PDF
    </button>
  </div>
</mat-dialog-actions>
